import { mapGetters } from "vuex";

export default {
    name: "Heading",
    props: {
        word: {
            type: String,
            required: true
        },
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            soundtext: null
        };
    },
    methods: {
        play() {
            this.$refs.audio.play();
        }
    },
    computed: {
        ...mapGetters("ThesaurusFilter", ["audio", "pronunciation"]),
        sourceHeading() {
            return this.$t("thesaurusDetailPageH1", { word: this.word });
        },
        audioIconTitle() {
            return this.$t("audioIconTitle", { word: this.slug });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/Heading/Heading.js